/**
 * @file 全局消息提示
 * @description 封装 Element Plus 消息提示，统一层级、关闭按钮和聚合策略。
 */
import { ElMessage } from 'element-plus'

/** 抽屉/弹层之上显示消息（el-drawer 默认 z-index 约 2000+） */
const MESSAGE_Z_INDEX = 10000

/**
 * 统一错误提示（合并相同内容、可手动关闭）。
 * @param message 用户可见错误文案。
 */
export const showAppError = (message: string): void => {
  ElMessage.error({
    message,
    grouping: true,
    showClose: true,
    duration: 5000,
    zIndex: MESSAGE_Z_INDEX,
    customClass: 'app-message-multiline'
  })
}

/**
 * 统一成功提示。
 * @param message 用户可见成功文案。
 */
export const showAppSuccess = (message: string): void => {
  ElMessage.success({
    message,
    grouping: true,
    showClose: true,
    duration: 3000,
    zIndex: MESSAGE_Z_INDEX
  })
}

/**
 * 统一警告提示。
 * @param message 用户可见警告文案。
 */
export const showAppWarning = (message: string): void => {
  ElMessage.warning({
    message,
    grouping: true,
    showClose: true,
    duration: 3000,
    zIndex: MESSAGE_Z_INDEX
  })
}
